/* istanbul ignore file */
import { AxiosResponse } from 'axios';
import { CUSTOM_ERROR_CODES } from 'constants/error';
import { ErrorNames } from 'types/error';

type HandlerResponse = Promise<AxiosResponse | void>;

const customErrorHandler = (
  response: AxiosResponse
): undefined | (() => HandlerResponse | void) => {
  const customErrorMap: {
    [key in ErrorNames]: undefined | (() => HandlerResponse | void);
  } = {
    SERVICE_DISABLED_WITH_TOGGLE_BASED: undefined,
    SERVICE_DISABLED_WITH_TIME_BASED: undefined,
  };

  const customError = (CUSTOM_ERROR_CODES as Record<number, ErrorNames>)[
    response?.data?.errorCode
  ];

  if (customError) {
    return customErrorMap[customError];
  }
  return undefined;
};

export { customErrorHandler };
